import { commonUtils } from '@/helpers/commonUtils'
import styles from './PdfPage2.module.less'
import PdfPage, { PageHeader } from '../PdfPage/PdfPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
interface Props {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  no: number
}

function PdfPage2(props: Props) {
  const { t } = useTranslation()
  useEffect(() => {
    props.onRendered(1)
  }, [])
  return (
    <PdfPage no={props.no} bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-2/PDF-bg-2.jpg')}>
      <div className={styles.pdfPage2}>
        <PageHeader project={props.project} />
        <p className={styles.title}>{t('dashboard.pdf.content')}</p>
        <div className={styles.contentWrap}>
          <div className={styles.content}>
            <div className={styles.contentItem}>
              <div className={styles.left}>
                <img
                  className={styles.bg}
                  src={commonUtils.getImagePath('PDFDownload/pdf-page-2/left-bg.png')}
                  alt=''
                />
                <p className={styles.text}>01</p>
              </div>

              <div className={styles.right}>
                {t('dashboard.projectDetailPage.basicInformation')}
              </div>
            </div>

            <div className={styles.contentItem}>
              <div className={styles.left}>
                <img
                  className={styles.bg}
                  src={commonUtils.getImagePath('PDFDownload/pdf-page-2/left-bg.png')}
                  alt=''
                />
                <p className={styles.text}>02</p>
              </div>

              <div className={styles.right}>{t('dashboard.projectDetailPage.primaryAnalysis')}</div>
            </div>

            <div className={styles.contentItem}>
              <div className={styles.left}>
                <img
                  className={styles.bg}
                  src={commonUtils.getImagePath('PDFDownload/pdf-page-2/left-bg.png')}
                  alt=''
                />
                <p className={styles.text}>03</p>
              </div>

              <div className={styles.right}>{t('dashboard.projectDetailPage.detailAnalysis')}</div>
            </div>

            <div className={styles.contentItem}>
              <div className={styles.left}>
                <img
                  className={styles.bg}
                  src={commonUtils.getImagePath('PDFDownload/pdf-page-2/left-bg.png')}
                  alt=''
                />
                <p className={styles.text}>04</p>
              </div>

              <div className={styles.right}>{t('dashboard.projectDetailPage.heatmapAnalysis')}</div>
            </div>
          </div>
        </div>
      </div>
    </PdfPage>
  )
}

export default PdfPage2
